import { selectInviteVerification } from "app/containers/OnBoarding/redux/selector";
import { actions as onBoardingActions } from "app/containers/OnBoarding/redux/slice";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../redux/slice";

export default function useInviteHandler(
  setIsEmail: (val: boolean) => void,
  searchParams: URLSearchParams
) {
  const dispatch = useDispatch();
  const inviteData = useSelector(selectInviteVerification);

  useEffect(() => {
    if (inviteData.email) {
      dispatch(
        actions.setSignupFormValues({
          name: "email",
          value: inviteData.email,
        })
      );
    }

    return () => {};
  }, [inviteData]);

  useEffect(() => {
    const token = searchParams.get("token");
    if (token) {
      dispatch(onBoardingActions.setIsLoading(true));
      dispatch(
        onBoardingActions.emailInviteVerification({
          token,
          callback() {
            setIsEmail(true);
            dispatch(
              actions.setSignupFormValues({
                name: "email",
                value: inviteData.email,
              })
            );
          },
        })
      );
    }
  }, [searchParams]);
}
